import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const NAV_ITEMS = [
  { label: 'Dashboard', path: '/', icon: '🏠', exact: true },
  { label: 'Quotes', path: '/quotes', icon: '💬' },
  { label: 'Salesperson & Routing', path: '/salesperson-routing', icon: '👥' },
  { label: 'Email templates', path: '/email-templates', icon: '✉️' },
  { label: 'Configuration', path: '/configuration', icon: '⚙️' },
];

export default function AppNav() {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (item) =>
    item.exact
      ? location.pathname === item.path
      : location.pathname.startsWith(item.path);

  return (
    <nav style={{
      background: '#ffffff',
      borderBottom: '2px solid #e1e3e5',
      display: 'flex',
      alignItems: 'stretch',
      boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
      position: 'sticky',
      top: 0,
      zIndex: 200,
    }}>
      {/* Navigation Links */}
      {NAV_ITEMS.map((item) => {
        const active = isActive(item);
        return (
          <button
            key={item.path}
            onClick={() => navigate(item.path)}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '7px',
              padding: '0 18px',
              height: '48px',
              background: active ? 'rgba(92, 106, 196, 0.08)' : 'transparent',
              border: 'none',
              borderBottom: active ? '3px solid #5c6ac4' : '3px solid transparent',
              borderTop: '3px solid transparent',
              cursor: 'pointer',
              color: active ? '#5c6ac4' : '#6d7175',
              fontSize: '13px',
              fontWeight: active ? '600' : '400',
              transition: 'all 0.15s ease',
              whiteSpace: 'nowrap',
              fontFamily: 'sans-serif',
            }}
            onMouseEnter={e => {
              if (!active) {
                e.currentTarget.style.color = '#202223';
                e.currentTarget.style.background = 'rgba(0,0,0,0.04)';
              }
            }}
            onMouseLeave={e => {
              if (!active) {
                e.currentTarget.style.color = '#6d7175';
                e.currentTarget.style.background = 'transparent';
              }
            }}
          >
            <span style={{ fontSize: '15px' }}>{item.icon}</span>
            <span>{item.label}</span>
          </button>
        );
      })}
    </nav>
  );
}
